import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";

export default class CustomerParserController {
  constructor(options) {
    console.debug("CustomerParserController", { that: this, options });
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    $ctrl.bus = new ServiceBus();
  }

  submit() {
    const $ctrl = this;
    const IdIn = ($ctrl.custIds || "NO_CUSTOMER_ID").split(/[\s,]+/gi).filter(custid => !!custid);
    const request = {
      IdIn,
      take: 500,
      fields: "Id"
    };
    $ctrl.bus.send("QueryRetailers.json", request).then(({ data }) => {
      $ctrl.$close(data.results.map(p => p.id));
    });
  }

  $onDestroy() {
    this.bus.dispose();
  }
}
